import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {getSummaryTicketPrice} from '../../../../../selectors/placed-order'
import {SummaryDivider} from '../../summary-divider'
import s from './ticket.scss'
import {TicketProps} from './index'

export const Ticket = ({ticket}: TicketProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const {labeledPrice, total} = getSummaryTicketPrice(ticket, t, getFormattedMoney)

  const getTicketAriaLabel = () => {
    const name = `${t('ticketsThankYou.ticketName')}: ${ticket.name}`
    const qty = t('mobile.thanks.quantity', {quantity: ticket.orderedCount})
    return `${name}, ${labeledPrice}, ${qty}`
  }

  return (
    <div data-hook={DH.TICKET_WRAPPER}>
      <div className={s.ticket} data-hook={DH.TICKET} aria-label={getTicketAriaLabel()}>
        <div className={s.name} data-hook={DH.TICKET_NAME}>
          {ticket.name}
        </div>
        <div className={s.singlePrice}>{labeledPrice}</div>
        <div className={s.row}>
          <div className={s.quantity} data-hook={DH.TICKET_QUANTITY}>
            {t('mobile.thanks.quantity', {quantity: ticket.orderedCount})}
          </div>
          <div className={s.price} data-hook={DH.TICKET_TOTAL_PRICE}>
            {total}
          </div>
        </div>
      </div>
      <SummaryDivider />
    </div>
  )
}
